import type { IStore } from "~/state/store";
import type { TWasmMapClick } from "../wasm";
import type { IConfig } from "~/config";
import type WasmStoreMapping from "../mapping";
import { openPanoramaAt } from "~/util/providers/pano";
import { openDIM } from "~/util/userweb";
import { getPOI } from "~/route/utils";
import Scene from "~/scene";
import { makeEvent } from "~/lib/signals";
import { toggleActiveSubscription } from "~/state/share-position/state";
import { getLocation } from "~/whereami";
import { isRouteActive } from "./util";

export function onMapClick(data: TWasmMapClick, store: IStore, CONFIG: IConfig, mapping: WasmStoreMapping, inputListener: boolean) {
	// nekde je nejaky input, co ceka, ze se klikne do mapy a dostane o tom info
	if (inputListener && !data.wasmId) {
		makeEvent("inputmapclick-click", undefined, {
			longitude: data.longitude,
			latitude: data.latitude,
			poi: data.pois?.length ? data.pois[0] : null,
		});
	// vlastni body - kliklo se do mapy, ale ne na nejaky nas element v mape
	} else if (Mapy.getComponent("userMarks").isActive()) {
		!data.wasmId && Mapy.getComponent("userMarks").addItem([data.longitude, data.latitude]);
	// rucni mereni - kliklo se do mapy, ale ne na nejaky nas element v mape
	} else if (Mapy.getComponent("distanceMeter").isActive()) {
		Mapy.getComponent("distanceMeter").wasmClick([data.longitude, data.latitude], data.clientX, data.clientY);
	// routovac
	} else if (isRouteActive() && !Mapy.CML.state.route.readOnly && !data.wasmId && (data.ctrlKey || data.metaKey)) {
		Mapy.CML.state = {
			route: {
				loading: true,
			},
		};

		const coords = Scene.coordsFromWGS84(data.longitude, data.latitude);

		getPOI(coords).then(dataPoi => {
			const items = Mapy.CML.state.route.items;

			items.push(dataPoi);
			Mapy.CML.state = {
				route: {
					items,
					scroll: true,
					zoom: false,
					loading: false,
				},
			};
			Mapy.getComponent("history").save();
		}, () => {});
	// gpx
	} else if (Mapy.getComponent("gpx").isActive()) {
		const { wasmMarker, wasmGeometry } = mapping.getWasmToStoreData(data.wasmId);

		const customId = wasmMarker
			? wasmMarker.customData?.customId
			: wasmGeometry
				? wasmGeometry.customData?.customId
				: "";

		Mapy.getComponent("gpx").itemClick(customId);
	// kliklo se na nejaky marker v mape, ktery zjistime az kdyz si precteme jeho data
	} else if (data.wasmId) {
		const { wasmMarker, wasmGeometry } = mapping.getWasmToStoreData(data.wasmId);

		if (wasmMarker) {
			// neco, co reprezentuje POI
			if (wasmMarker.customData?.poi) {
				const source = wasmMarker.customData.poi.source;

				if (wasmMarker.type === "photo") {
					Mapy.getComponent("photoDetail").setData({
						source,
						id: wasmMarker.customData.poi.id,
					}).activate();
					Mapy.getComponent("history").save();
				} else {
					Mapy.getComponent("detail").setState({
						...wasmMarker.customData.poi,
						show: false,
					}).then(() => {
						Mapy.getComponent("history").save();
					}, () => {});
				}
			// trvale nad mapou a veci z MM
			} else if (wasmMarker?.customData?.dim) {
				openDIM(wasmMarker.customData.dim, { inFrame: CONFIG.inFrame });
			// aktivita v MM
			} else if (wasmMarker.customData?.component === "activities") {
				Mapy.getComponent("activities").open(wasmMarker.customData.customId);
			// sdilena polohy
			} else if (wasmMarker.customData?.subscriptionId) {
				store.dispatch(toggleActiveSubscription(wasmMarker.customData.subscriptionId));
			} else if (wasmMarker.type === "route-popup-info") {
				if (isRouteActive() && typeof wasmMarker.customData?.order === "number" && wasmMarker.customData.order !== Mapy.CML.state.route.index) {
					Mapy.CML.state = {
						route: {
							index: wasmMarker.customData.order,
							zoom: false,
						},
					};
				}

				return;
			}
		}

		if (wasmGeometry) {
			// prepinani alternativy v routovaci
			if (isRouteActive() && wasmGeometry.customData?.route?.routeIndex !== undefined && wasmGeometry.customData?.route?.routeIndex !== Mapy.CML.state.route.index) {
				Mapy.CML.state = {
					route: {
						index: wasmGeometry.customData?.route?.routeIndex,
						zoom: false,
					},
				};
			} else if (wasmGeometry?.customData?.dim) {
				openDIM(wasmGeometry.customData.dim, { inFrame: CONFIG.inFrame });
			}
		}
	// kliklo se na panorama cary v mape
	} else if (data.rasterLayer === "panoLayer") {
		openPanoramaAt({
			lon: data.longitude,
			lat: data.latitude,
			zoom: store.getState().map.zoom,
			selYear: Mapy.getComponent("pano").getYear(),
		}).then(() => {
			Mapy.getComponent("history").save();
		}, () => {});
	// nic interaktivniho neni aktivni, ale kliklo se na POI
	} else if (data.pois?.length) {
		if (data.pois[0].source === "plot") {
			Mapy.getComponent("pois").openCadastral(data.pois[0].id);
		} else {
			Mapy.getComponent("detail").setState({
				source: data.pois[0].source,
				id: data.pois[0].id,
				show: false,
			}).then(() => {
				Mapy.getComponent("history").save();
			}, () => {});
		}
	} else if (data.ctrlKey || data.metaKey) {
		const coords = Scene.coordsFromWGS84(data.longitude, data.latitude);

		getLocation(coords).then(locationData => {
			Mapy.getComponent("detail").setState({
				source: locationData.source,
				id: locationData.id,
				coords,
				gpsCoords: locationData.gpsCoords,
				manual: true,
				show: false,
			}).then(() => { Mapy.getComponent("history").save(); }, () => {});
		}, () => {
			Mapy.getComponent("detail").setState({
				source: "coor",
				id: `${data.longitude},${data.latitude}`,
				coords,
				manual: true,
				show: false,
			}).then(() => { Mapy.getComponent("history").save(); }, () => {});
		});
	}
}
